import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilService } from 'src/app/service/util';
import { environment } from 'src/environments/environment';
import { IntegracaoNetrin, IntegracaoNetrinDto, ParceiroDeNegocioAtualizar, ParceiroDeNegocioDto } from '../interface/dados-cliente-fornecedor';
import { FiltroDadosParceiroDeNegocio, IFiltroDadosParceiroDeNegocio } from '../interface/filtro-dados-cliente-fornecedor';

@Injectable({
  providedIn: 'root'
})
export class NetrinService {

  api: String = `${environment.urlApiProtheus}/wsrnetrin`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) {}

  getClienteFornecedorLista(filtro: IFiltroDadosParceiroDeNegocio): Observable<ParceiroDeNegocioDto> {
    return this.httpClient.get<ParceiroDeNegocioDto>(`${this.api}/cliente-fornecedor/lista`, this.utilService.filtrosHttpOptions(filtro));
  }

  getDadosIntegracaoLista(filtro: IFiltroDadosParceiroDeNegocio): Observable<IntegracaoNetrinDto> {
    return this.httpClient.get<IntegracaoNetrinDto>(`${this.api}/dados-integracao/lista`, this.utilService.filtrosHttpOptions(filtro));
  }

  postConsultarClienteFornecedor(body: ParceiroDeNegocioAtualizar): Observable<void> {
    return this.httpClient.post<void>(`${this.api}/consultar/cliente-fornecedor`, body,this.utilService.filtrosHttpOptions());
  }

  postAtualizarClienteFornecedor(body: IntegracaoNetrinDto): Observable<void> {
    return this.httpClient.post<void>(`${this.api}/atualizar/cliente-fornecedor`, body,this.utilService.filtrosHttpOptions());
  }

}
